<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-toolbar-title>Industry Group Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :options.sync="pagination"
              :loading="loading"
              item-key="name"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row">
                <tr>
                  <td class="text-xs-left">{{ row.item.indGrp }}</td>
                  <td class="text-xs-left">{{ row.item.indGrpDesc }}</td>
                  <td class="text-xs-center">
                    <v-btn icon color="primary" text type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'Industry Group', value: 'indGrp' },
        { text: 'Industry Group Description', value: 'indGrpDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      loading: true,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      const apiUrl = this.menu.industryList
      if (apiUrl) {
        this.helplistloading = true
        this.$http
          .get(expandURI(apiUrl))
          .then((result) => {
            const { data } = result.data.industryLists
            if (data) {
              this.items = []
              data.map((industry) => {
                const industryList = {
                  indGrp: industry.indGrp,
                  indGrpDesc: industry.indGrpDesc
                }
                this.items.push(industryList)
              })
              this.loading = false
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.loading = false
              this.message(data)
              this.fieldMessage(data)
            }
          })
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doSelect(data) {
      const textObj = {
        indGrp: data.indGrp,
        indGrpDesc: data.indGrpDesc
      }
      this.$emit('doAssign', textObj)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.underwriting.policyRiskSettings.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
